import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    path: String
  }

  refreshPage() {
    const newPath = this.hasPathValue ? this.pathValue : window.location.href
    Turbo.visit(newPath)
  }
}
